// @ts-nocheck
/* eslint-enable */
import Promise from 'promise';
import forEach from 'lodash/forEach';
import keys from 'lodash/keys';

import api from 'app/shared/utils/api';
import constants from 'app/shared/constants/ConstantsBundle';
import trackingUtils from 'app/shared/utils/trackingUtils';
import { logError } from '@zg-rentals/log-error';

const GOOGLE_AD_API_SCRIPT_ID = 'google-ad-api';
const GOOGLE_AD_API_SCRIPT_SRC = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';

let googleAdApiLoadPromise = null;

const hasGoogleAdApiLoaded = () => {
  return typeof window !== 'undefined' && Boolean(window.googletag?.pubads);
};

const getGoogleAdApiScript = () => {
  return typeof document !== 'undefined' ? document.getElementById(GOOGLE_AD_API_SCRIPT_ID) : null;
};

const dispatchGoogleAdApiLoaded = (dispatch, getState) => {
  if (!getState || !getState()?.ads?.gadsInit) {
    dispatch({
      type: constants.GADS_INIT_SUCCESS,
    });
  }
};

const AdActions = {
  adTags({ aliasEncoded, minLat, minLon, maxLat, maxLon, lowPrice, highPrice }) {
    return function (dispatch) {
      if (aliasEncoded || (minLat && minLon && maxLat && maxLon)) {
        return dispatch(
          api.analytics.adTags({ aliasEncoded, minLat, minLon, maxLat, maxLon, lowPrice, highPrice }),
        ).then((result) => {
          const attributes = {};

          if (result.data) {
            forEach(result.data, (obj) => {
              const key = keys(obj)[0];

              attributes[key] = obj[key];
            });
          } else {
            return;
          }

          return {
            attributes,
          };
        });
      } else {
        return Promise.resolve({
          warning: 'No alias encoding or lat/lon provided to adTags',
        });
      }
    };
  },
  loadGoogleAdApi() {
    return (dispatch, getState) => {
      const loadGoogleAds = () => {
        let gads;
        if (typeof window === 'undefined') {
          return Promise.resolve();
        }

        if (hasGoogleAdApiLoaded()) {
          dispatchGoogleAdApiLoaded(dispatch, getState);
          return Promise.resolve();
        }

        if (getGoogleAdApiScript()) {
          return googleAdApiLoadPromise || Promise.resolve();
        }

        return new Promise((resolve) => {
          let googleAdApiDidLoad = false;
          window.googletag = window.googletag || {};
          window.googletag.cmd = window.googletag.cmd || [];

          gads = document.createElement('script');
          gads.id = GOOGLE_AD_API_SCRIPT_ID;
          gads.async = true;
          gads.type = 'text/javascript';
          gads.src = GOOGLE_AD_API_SCRIPT_SRC;
          document.documentElement.firstChild.appendChild(gads);
          gads.onload = gads.onreadystatechange = function () {
            if (googleAdApiDidLoad) {
              return;
            }

            googleAdApiDidLoad = true;
            window.googletag.cmd.push(() => {
              if (window.googletag.pubads) {
                window.googletag.pubads().enableSingleRequest();
                window.googletag.pubads().enableAsyncRendering();
                window.googletag.enableServices();

                // DataGrail: check if marketing/advertising is allowed
                if (window.DG_BANNER_API && !window.DG_BANNER_API.categoryEnabled('marketing')) {
                  window.googletag.pubads().setRequestNonPersonalizedAds(1);
                  window.googletag.pubads().setPrivacySettings({ restrictDataProcessing: true });
                }

                if (!__DEV__) {
                  window.googletag.pubads().collapseEmptyDivs();
                }
              }
            });

            dispatchGoogleAdApiLoaded(dispatch, getState);
            resolve();
          };
        });
      };

      if (hasGoogleAdApiLoaded()) {
        dispatchGoogleAdApiLoaded(dispatch, getState);
        return Promise.resolve();
      }

      if (googleAdApiLoadPromise) {
        return googleAdApiLoadPromise;
      }

      // Wait for DataGrail to be loaded before loading ads
      googleAdApiLoadPromise = trackingUtils
        .checkDataGrail()
        .catch((error) => {
          // If DataGrail fails to load (e.g., blocked by ad blocker), proceed with loading ads
          // but they will default to non-personalized mode due to lack of consent data
          logError({
            error,
            errorType: 'DataGrailLoadError',
            context: 'Failed to load DataGrail before initializing ads - proceeding with non-personalized ads',
          });
        })
        .then(loadGoogleAds);

      return googleAdApiLoadPromise;
    };
  },
  prebidInitLoaded(bool) {
    return (dispatch) => {
      dispatch({
        type: constants.PREBID_INIT,
        payload: {
          loaded: bool,
        },
      });
    };
  },
  refreshAd(force) {
    return (dispatch) => {
      dispatch({
        type: constants.REFRESH_AD,
        payload: {
          force,
        },
      });
    };
  },
  setAdSlot(slot, data) {
    return function (dispatch) {
      dispatch({
        type: constants.SET_AD_SLOT,
        payload: {
          data,
          slot,
        },
      });
    };
  },
};

export default AdActions;
